export default __webpack_public_path__ + "static/media/icon_login.47b99715.svg";